import { Modal, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import styles from "../../../styles/pages/Auth/login/RecaptchaModal.module.css";
import { checkEmailException } from "../../../utility/helper";
import {
  generateImageCaptcha,
  generateTextCaptcha,
  saveUserPass,
  setAuthData,
  signinUpMiniApp,
} from "../../../redux/main/action/main";
import axios from "axios";
import { notify } from "../../../utility/Toastify/toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import ConfirmAlert from "../ConfirmAlert";
import ImageCaptcha from "../../../components/auth/captcha/ImageCaptcha";
import TextCaptcha from "../../../components/auth/captcha/TextCaptcha";
import { FaPuzzlePiece, FaQuestion, FaShieldHalved } from "react-icons/fa6";

function RecaptchaModal({
  open,
  onClose,
  data,
  useCase,
  referralCode = "",
  isMiniApp = false,
}) {
  const { captchaData, imageCaptchaData, telegramData } = useSelector(
    (state) => state.main,
  );

  const [userInput, setUserInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [pass, setPass] = useState("");
  const [showConfirmAlert, setShowConfirmAlert] = useState(false);
  const [currentTab, setCurrentTab] = useState("image");
  const [params] = useSearchParams();
  // Get the value of the 'telegram_auth' parameter
  const telegramAuth = params.get("tgWebAppStartParam");

  // Get the value of the 'user' parameter
  const telegram_id = telegramData?.telegramId || telegramAuth?.slice(0, 20);
  const telegramId = telegram_id?.replace(/^0+/, "");

  const next = telegramData?.next || telegramAuth?.slice(-5);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const closeModal = (e) => {
    if (e) {
      e.stopPropagation();
    }
    console.log("test new version 26.10.4:14:7");

    if (loading) return;

    if (onClose) onClose();
    setUserInput("");
    setLoading(false);
    setUserEmail("");
    setPass("");
    setShowConfirmAlert(false);
  };

  const login = async () => {
    const configData = {
      operation_mode: "cognito_login",
      email: checkEmailException(data?.email),
      password: data?.pass,
      captcha_id:
        currentTab === "text"
          ? captchaData?.captcha_id
          : imageCaptchaData?.captcha_id,
      captcha_answer: userInput,
    };

    await axios
      .post(
        "https://weu658vyjj.execute-api.ap-southeast-2.amazonaws.com/dev/api",
        configData,
      )
      .then((res) => {
        // console.log(res);
        const {
          // message,
          idToken: { jwtToken: token, payload: userData },
          refreshToken: { token: refreshToken },
        } = res?.data;

        dispatch(setAuthData(userData, token, refreshToken));

        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        if (isMiniApp) {
          localStorage.setItem("telegramData", telegramAuth);
          dispatch(
            signinUpMiniApp(
              telegramId,
              userData?.["custom:custom_username"],
              userData?.email,
            ),
          );
        }

        navigate(isMiniApp ? "/mini-portfolio" : "/welcome");
      })
      .catch((err) => {
        console.log(err);
        const { message } = err?.response?.data;
        if (isMiniApp && message?.includes("confirmed")) {
          navigate("/mini-resend-confirm");
          return notify("Please confirm your account", "info");
        }

        if (message?.includes("confirmed")) {
          setShowConfirmAlert(true);
          return;
        }
        if (
          message?.toLowerCase()?.includes("email") ||
          message?.toLowerCase().includes("password")
        ) {
          closeModal();
        }

        notify(message, "error");

        setUserInput("");

        if (currentTab === "image") {
          dispatch(generateImageCaptcha());
        } else {
          dispatch(generateTextCaptcha());
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const signUp = async () => {
    const configData = {
      operation_mode: "cognito_signup",
      email: data?.email.toLowerCase(),
      password: data?.pass,
      captcha_id:
        currentTab === "text"
          ? captchaData?.captcha_id
          : imageCaptchaData?.captcha_id,
      captcha_answer: userInput,
      additional_attributes: {
        "custom:custom_username": data?.username,
        "custom:referal_code": referralCode,
      },
    };

    await axios
      .post(
        "https://weu658vyjj.execute-api.ap-southeast-2.amazonaws.com/dev/api",
        configData,
      )
      .then((res) => {
        console.log(res?.data);
        dispatch(saveUserPass([data?.email.toLowerCase(), data?.pass]));
        localStorage.setItem("userPass", [
          data?.email.toLowerCase(),
          data?.pass,
        ]);
        navigate(isMiniApp ? "/mini-auth-confirm" : "/auth/confirm");
      })
      .catch((err) => {
        console.log(err);
        const { message } = err?.response?.data;

        notify(message, "error");

        if (message?.toLowerCase()?.includes("exists")) {
          closeModal();
          setLoading(false);
        }

        if (message?.toLowerCase()?.includes("captcha")) {
          setUserInput("");
          if (currentTab === "image") {
            dispatch(generateImageCaptcha());
          } else {
            dispatch(generateTextCaptcha());
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onSubmit = () => {
    if (!userInput) return;

    setLoading(true);
    setUserEmail(data?.email.toLowerCase());
    setPass(data?.pass);

    if (useCase === "login") {
      return login();
    }

    if (useCase === "signup") {
      console.log(data);
      return signUp();
    }
  };

  const changeTab = (tab) => () => {
    if (loading) return;

    if (userInput) {
      setUserInput("");
    }
    setCurrentTab(tab);
  };

  const handleEnterKeyDown = (e) => {
    if (e.key === "Enter" && userInput) {
      onSubmit();
    }
  };

  if (!open) return null;

  const modalTitle = (
    <div className={styles.modalHero}>
      <span className={styles.modalHeroBadge}>
        <FaShieldHalved />
      </span>
      <div className={styles.modalHeroTitles}>
        {/* <span className={styles.modalEyebrow}>
          Security Check · {useCase === "login" ? "Sign in" : "Create account"}
        </span> */}
        <h2 className={styles.modalTitle}>Verify you are human</h2>
        <p className={styles.modalSubtitle}>
          Complete the challenge below to continue — it helps us keep your
          account safe.
        </p>
      </div>
    </div>
  );

  return (
    <Modal
      open={open}
      centered
      footer={null}
      onCancel={closeModal}
      title={modalTitle}
      maskClosable={false}
      className={styles.modal}
      width={520}
    >
      <div className={styles.modalBody}>
        <div className={styles.tabBar} role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={currentTab === "image"}
            className={`${styles.tabPill} ${currentTab === "image" ? styles.tabPillActive : ""}`}
            onClick={changeTab("image")}
            disabled={loading}
          >
            <span className={styles.tabIcon}>
              <FaPuzzlePiece />
            </span>
            Picture Challenge
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={currentTab === "text"}
            className={`${styles.tabPill} ${currentTab === "text" ? styles.tabPillActive : ""}`}
            onClick={changeTab("text")}
            disabled={loading}
          >
            <span className={styles.tabIcon}>
              <FaQuestion />
            </span>
            Answer a Question
          </button>
        </div>

        <div className={styles.captchaPanel}>
          {currentTab === "image" && (
            <ImageCaptcha
              captchaValue={userInput}
              setCaptchaValue={setUserInput}
              handleEnterKeyDown={handleEnterKeyDown}
              loading={loading}
            />
          )}

          {currentTab === "text" && (
            <TextCaptcha
              captchaValue={userInput}
              setCaptchaValue={setUserInput}
              handleEnterKeyDown={handleEnterKeyDown}
              loading={loading}
            />
          )}
        </div>

        <div className={styles.actionRow}>
          <Button
            loading={loading}
            disabled={!userInput}
            onClick={onSubmit}
            className={styles.submitBtn}
            size="large"
          >
            {useCase === "login" ? "Continue Login" : "Continue Signup"}
          </Button>
          <p className={styles.actionHint}>
            <FaShieldHalved /> Protected by CryptoCrispy security · Your data is
            encrypted end-to-end
          </p>
        </div>
      </div>

      <ConfirmAlert
        show={showConfirmAlert}
        setShow={setShowConfirmAlert}
        email={userEmail}
        password={pass}
      />
    </Modal>
  );
}

export default RecaptchaModal;

// COGNITO LOGIN
// let user = new CognitoUser({
//       Username: checkEmailException(data?.email),
//       Pool: PoolData,
//     });
//     let authDetails = new AuthenticationDetails({
//       Username: data?.email,
//       Password: data?.pass,
//       ValidationData: { captcha: "rtspa_mehdi_ravanbakhsh_761" },
//     });
//
//     user.authenticateUser(authDetails, {
//       onSuccess: (data) => {
//         // console.log(data);
//         dispatch(setToken(data?.idToken?.jwtToken));
//         dispatch(setUserData(data?.idToken?.payload));
//         axios.defaults.headers.common["Authorization"] =
//           `Bearer ${data?.idToken?.jwtToken}`;
//         // window.location.reload();
//         // notify("You have successfully logged in", "success");
//         localStorage.setItem(
//           "aws-amplify-federatedInfo",
//           JSON.stringify({ token: data?.idToken?.jwtToken }),
//         );
//         localStorage.setItem(
//           "aws-amplify-USERDATA",
//           JSON.stringify(data?.idToken?.payload),
//         );
//         localStorage.setItem("refreshToken", data?.refreshToken?.token);
//         setLoading(false);
//         // navigate("/ai-assistant/assistant");
//         navigate("/welcome");
//         // navigate("/dashboard");
//       },
//
//       onFailure: function (err) {
//         setLoading(false);
//         if (
//           err.message?.includes("username") ||
//           err.message?.includes("password")
//         ) {
//           closeModal();
//         }
//
//         if (err?.message === "User is not confirmed.") {
//           setShowConfirmAlert(true);
//           return;
//         }
//         if (err?.message.includes("captcha")) return;
//         notify(err?.message, "error");
//       },
//
//       newPasswordRequired: (data) => {
//         console.log("newPasswordRequired");
//         notify(data, "success");
//         setLoading(false);
//       },
//     });
